<div class="customer-header-badges">
  @if (loadingRiskLevel) {
    <span class="ni-shimmer risk-level-pill--skeleton"></span>
  } @else if (riskLevel) {
    <span class="risk-level-pill" [ngClass]="riskLevelClass(riskLevel)">
      <img
        class="risk-level-pill__face"
        [src]="riskLevelFace(riskLevel)"
        alt=""
        width="16"
        height="16"
      />
      {{ riskLevelLabel(riskLevel) }}
    </span>
  }

  <mihmo-care-path-badges
    [customerId]="customerId"
    [readonly]="true"
    [onlyActive]="true"
  ></mihmo-care-path-badges>
</div>
